import type { TimestampInMillis } from '@cobliteam/common-types';
import { Tooltip } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { isBefore } from '@cobliteam/utils/date';

export interface LicenseExpiredTooltipProps {
  date: TimestampInMillis;
}

const LicenseExpiredTooltip = ({ date }: LicenseExpiredTooltipProps) => {
  const licenseExpired = isBefore(date, new Date());

  if (!licenseExpired) return null;

  return (
    <Tooltip content='CNH vencida' arrow position='bottom' align='start'>
      <Icon name='triangle-alert' color='danger' />
    </Tooltip>
  );
};

export default LicenseExpiredTooltip;
